export const MONTANT_REFERENCE = {
	BUDGET: 'budget',
	BUDGET_N1: 'budget_n1',
	BUDGET_N2: 'budget_n2',
	REALISE: 'realise',
	REALISE_N1: 'realise_n1',
	REALISE_N2: 'realise_n2',
	BP_N1: 'bp_n1',
	BP_N2: 'bp_n2',
	ENGAGE: 'engage_n',
	LIQUIDE: 'liquide_n',
};

export const getMontantReferenceLibelle = (
	typeMontant: string,
	currentExcercice: number = null,
) => {
	switch (typeMontant) {
		case MONTANT_REFERENCE.BUDGET:
			return 'Budget cumulé';
		case MONTANT_REFERENCE.BUDGET_N1:
			return `Budget cumulé ${currentExcercice ? currentExcercice - 1 : 'N-1'}`;
		case MONTANT_REFERENCE.BUDGET_N2:
			return `Budget cumulé ${currentExcercice ? currentExcercice - 2 : 'N-2'}`;
		case MONTANT_REFERENCE.REALISE:
			return 'Réalisé';
		case MONTANT_REFERENCE.REALISE_N1:
			return `Réalisé ${currentExcercice ? currentExcercice - 1 : 'N-1'}`;
		case MONTANT_REFERENCE.REALISE_N2:
			return `Réalisé ${currentExcercice ? currentExcercice - 2 : 'N-2'}`;
		case MONTANT_REFERENCE.BP_N1:
			return `Budget Primitif ${currentExcercice ? currentExcercice - 1 : 'N-1'}`;
		case MONTANT_REFERENCE.BP_N2:
			return `Budget Primitif ${currentExcercice ? currentExcercice - 2 : 'N-2'}`;
		case MONTANT_REFERENCE.ENGAGE:
			return 'Engagé';
		case MONTANT_REFERENCE.LIQUIDE:
			return 'Liquidé';
		default:
			return '';
	}
};
